import moment from "moment";

export const isStartEndDateValid = (
  startDate: Date | string | null | undefined,
  endDate: Date | string | null | undefined
): boolean => {
  if (!startDate || !endDate) {
    return false;
  }

  const start = moment(startDate);
  const end = moment(endDate);

  return end.isSameOrAfter(start);
};
